'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import 'angular-validation-match';

import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import tutors from './tutors';
import students from './students';
import reports from './reports';
import timesheets from './timesheets';
import navbar from '../components/navbar/navbar.component';
import main from './main/main.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import uiSelect from 'ui-select';
import processA from './process';
import miscServices from '../components/services/';

//modals
import EditPresets from './modals/edit-presets';
import EditTutor from './modals/edit-tutor';
import EditStudent from './modals/edit-student';
import CreateStudent from './modals/create-student';
import CreateTutor from './modals/create-tutor';
import DeputyImport from './modals/deputy-import';

import './app.scss';

angular.module('accessApp', [ngCookies, ngResource, ngSanitize, uiRouter, uiBootstrap, _Auth,
  account, admin, 'validation.match', navbar, main, constants, util, tutors, timesheets, uiSelect,
  EditPresets, CreateStudent, CreateTutor, reports, processA, miscServices, EditTutor, students,
  EditStudent, DeputyImport
])
  .config(routeConfig)
  .directive('customOnChange', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var onChangeHandler = scope.$eval(attrs.customOnChange);
        element.on('change', onChangeHandler);
        element.on('$destroy', function () {
          element.off();
        });

      }
    };
  })
  .run(function ($rootScope, $location, Auth, $http) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in
    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
      if (current.name === 'timesheets') {
        if ($rootScope.changesToBeSaved) {
          if (!confirm('Your timesheet has unsaved changes. Click cancel to stay to stay on this page.')) {
            event.preventDefault();
          } else {
            $rootScope.changesToBeSaved = false;
          }
        }
      }

      Auth.isLoggedIn(function (loggedIn) {
        if (next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['accessApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js